import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for   Strategiesvalues
export const Strategiesvalues = createSlice({
  name: "Strategiesvalues",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    switch: false,
    data: {},
  },
  reducers: {
    Strategiesvalues_datagrid: (state, a) => {
      state.data = a.payload;
      state.switch = true
    },
    success_api_call_Strategiesvalues_datagrid: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
    },
    failure_api_call_Strategiesvalues_datagrid: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
    },
    Strategiesvalues_datagrid_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_Strategiesvalues_datagrid_complete_api: (state, action) => {
      state.api_completed = false;
    },
    false_switchStrategies:(state)=>{
        state.switch = false
    }
  },
});
export default Strategiesvalues.reducer;
export const {
  Strategiesvalues_datagrid,
  success_api_call_Strategiesvalues_datagrid,
  failure_api_call_Strategiesvalues_datagrid,
  create_Strategiesvalues_datagrid_complete_api,
  Strategiesvalues_datagrid_is_success,false_switchStrategies
} = Strategiesvalues.actions;
